<div class="wrapper--spacing-horizontal wrapper--spacing-vertical">
  <ul class="info-header">
    <li *ngIf="customer$ | async as customer">
      <label class="text-bold"
        >{{ 'feed-profit.detail.extended-simulation.report.farmcompany' | translate }}:</label
      >
      <label class="wide-label">
        {{ customer?.name }}, {{ customer?.street }} {{ customer?.houseNumber }}
        {{ customer?.houseNumberAddition }},
        {{ customer?.city }}
      </label>
    </li>
    <li *ngIf="customer$ | async as customer">
      <label class="text-bold"
        >{{ 'feed-profit.detail.extended-simulation.report.customernr' | translate }}:</label
      >
      <label>{{ customer?.externalId }}</label>
    </li>
    <li *ngIf="location$ | async as location">
      <label class="text-bold"
        >{{ 'feed-profit.detail.extended-simulation.report.location' | translate }}:</label
      >
      <label class="wide-label">
        {{ location?.name }}, {{ location?.street }} {{ location?.houseNumber }}
        {{ location?.houseNumberAddition }},
        {{ location?.city }}
      </label>
    </li>
    <li *ngIf="calculation">
      <label class="text-bold"
        >{{ 'feed-profit.settings.company-details.animals.number-of-silos' | translate }}:</label
      >
      <label>{{ calculation.companyDetails?.numberOfSilos }}</label>
    </li>
    <li *ngIf="calculation">
      <label class="text-bold"
        >{{
          'feed-profit.settings.extended-baseline-settings.amountOfGrowFinisher' | translate
        }}:</label
      >
      <label>{{ calculation.companyDetails?.amountOfGrowFinisher }}</label>
    </li>
  </ul>
</div>

<div
  class="page-break-after wrapper--spacing-horizontal"
  *ngIf="calculation && extendedSimulationData && extendedSimulationData.comparison"
>
  <table>
    <tbody>
      <tr>
        <!--header-->
        <td>
          <strong>{{
            'feed-profit.detail.extended-simulation.report.assumptions' | translate
          }}</strong>
        </td>
        <td colspan="2">
          <strong>
            {{ 'feed-profit.detail.extended-simulation.report.current' | translate }}
          </strong>
        </td>
        <td colspan="2">
          <strong>
            {{ 'feed-profit.detail.extended-simulation.report.alternative' | translate }}
          </strong>
        </td>
      </tr>

      <tr>
        <td>{{ 'feed-profit.genders.label' | translate }}</td>
        <td colspan="2">
          {{
            calculation.genders ? ('feed-profit.genders.' + calculation.genders | translate) : '-'
          }}
        </td>
        <td colspan="2">
          {{
            calculation.extendedSimulation?.genders
              ? ('feed-profit.genders.' + calculation.extendedSimulation?.genders | translate)
              : '-'
          }}
        </td>
      </tr>
      <tr>
        <td>
          {{
            'feed-profit.settings.extended-baseline-settings.squareMeterPerGrowFinisher' | translate
          }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(calculation.extendedBaseLine?.squareMeterPerGrowFinisher) }}
        </td>
        <td colspan="2">
          {{
            getSummaryValue(
              calculation.extendedSimulation?.extendedBaseLine?.squareMeterPerGrowFinisher
            )
          }}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'feed-profit.settings.extended-baseline-settings.mortalityPercentage' | translate }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(calculation.extendedBaseLine?.mortalityPercentage) }}
        </td>
        <td colspan="2">
          {{
            getSummaryValue(calculation.extendedSimulation?.extendedBaseLine?.mortalityPercentage)
          }}
        </td>
      </tr>
      <tr>
        <td>
          {{
            'feed-profit.settings.extended-baseline-settings.fertilizerPerGrowFinisherInCubicMeters'
              | translate
          }}
          ({{ currencySymbol }})
        </td>
        <td colspan="2">
          {{ getSummaryValue(calculation.extendedBaseLine?.fertilizerPricePerCubicMeter) }}
        </td>
        <td colspan="2">
          {{
            getSummaryValue(
              calculation.extendedSimulation?.extendedBaseLine?.fertilizerPricePerCubicMeter
            )
          }}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'feed-profit.settings.extended-baseline-settings.growFinisherPrice' | translate }} ({{
            currencySymbol
          }})
        </td>
        <td colspan="2">{{ getSummaryValue(calculation.extendedBaseLine?.growFinisherPrice) }}</td>
        <td colspan="2">
          {{ getSummaryValue(calculation.extendedSimulation?.extendedBaseLine?.growFinisherPrice) }}
        </td>
      </tr>
      <tr>
        <td>
          {{
            'feed-profit.detail.extended-simulation.report.growFinisherPricePerSlaugtheredWeight'
              | translate
          }}
          ({{ currencySymbol }})
        </td>
        <td colspan="2">{{ getSummaryValue(calculation.extendedBaseLine?.revenuePerKg) }}</td>
        <td colspan="2">
          {{ getSummaryValue(calculation.extendedSimulation?.extendedBaseLine?.revenuePerKg) }}
        </td>
      </tr>

      <tr>
        <td colspan="5">&nbsp;</td>
      </tr>

      <tr>
        <!--header-->
        <td>
          <strong>
            {{
              'feed-profit.detail.extended-simulation.report.calculationFeedProfitGrowFinisher'
                | translate
            }}</strong
          >
        </td>
        <td colspan="2">
          <strong>
            {{ 'feed-profit.detail.extended-simulation.report.current' | translate }}</strong
          >
        </td>
        <td colspan="2">
          <strong>
            {{ 'feed-profit.detail.extended-simulation.report.alternative' | translate }}</strong
          >
        </td>
      </tr>

      <tr>
        <td>
          {{
            'feed-profit.detail.extended-simulation.report.avgAmountDeliveredGrowFinisher'
              | translate
          }}
        </td>
        <td colspan="2">
          {{
            getSummaryValue(
              extendedSimulationData.comparison?.avgAmountDeliveredGrowFinisher,
              '1.00-00'
            )
          }}
        </td>
        <td colspan="2">
          {{
            getSummaryValue(
              extendedSimulationData.extended?.avgAmountDeliveredGrowFinisher,
              '1.00-00'
            )
          }}
        </td>
      </tr>
      <tr>
        <td>
          {{
            'feed-profit.settings.extended-baseline-settings.squareMeterPerGrowFinisher' | translate
          }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.squareMeterPerGrowFinisher) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.squareMeterPerGrowFinisher) }}
        </td>
      </tr>
      <tr>
        <td>{{ 'feed-profit.settings.extended-baseline-settings.startWeight' | translate }}</td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.startWeight) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.startWeight) }}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'feed-profit.settings.extended-baseline-settings.slaughteredWeightInKg' | translate }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.slaughteredWeightInKg) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.slaughteredWeightInKg) }}
        </td>
      </tr>
      <tr>
        <td>{{ 'feed-profit.detail.extended-simulation.report.livingWeight' | translate }}</td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.livingWeight) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.livingWeight) }}
        </td>
      </tr>
      <tr>
        <td>{{ 'feed-profit.settings.extended-baseline-settings.growth' | translate }}</td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.growth) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.growth) }}
        </td>
      </tr>
      <tr>
        <td>{{ 'feed-profit.detail.extended-simulation.report.occupancyRate' | translate }}</td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.occupancyRate) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.occupancyRate) }}
        </td>
      </tr>
      <tr>
        <td>{{ 'feed-profit.detail.quick-simulation.table.amount' | translate }}</td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.amount) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.amount) }}
        </td>
      </tr>
      <tr>
        <td>{{ 'feed-profit.detail.quick-simulation.table.feed-conversion' | translate }}</td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.feedConversion) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.feedConversion) }}
        </td>
      </tr>
      <tr>
        <td>{{ 'feed-profit.detail.extended-simulation.report.energyConversion' | translate }}</td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.avergeEnergyConversion) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.avergeEnergyConversion) }}
        </td>
      </tr>
      <tr>
        <td>{{ 'feed-profit.detail.extended-simulation.report.packetTotalKg' | translate }}</td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.packetTotalKg) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.packetTotalKg) }}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'feed-profit.detail.extended-simulation.report.packetPricePerKg' | translate }} ({{
            currencySymbol
          }})
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.packetPricePerKg) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.packetPricePerKg) }}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'feed-profit.detail.extended-simulation.report.feedCostPerKgPerGrowth' | translate }}
          ({{ currencySymbol }})
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.feedCostPerKgPerGrowth) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.feedCostPerKgPerGrowth) }}
        </td>
      </tr>
      <!-- <tr>
        <td>{{ 'feed-profit.detail.extended-simulation.report.fosfateEfficiency' | translate }}</td>
        <td colspan="2">?</td>
        <td colspan="2">?</td>
      </tr> -->

      <tr>
        <td colspan="5">&nbsp;</td>
      </tr>

      <tr>
        <!--header-->
        <td>
          <strong>{{
            'feed-profit.detail.extended-simulation.report.feedprofit' | translate
          }}</strong>
        </td>
        <td>
          <strong>{{
            'feed-profit.detail.extended-simulation.report.perDeliveredGrowFinisher' | translate
          }}</strong>
        </td>
        <td>
          <strong>{{
            'feed-profit.detail.extended-simulation.report.perKgGrowth' | translate
          }}</strong>
        </td>
        <td>
          <strong>{{
            'feed-profit.detail.extended-simulation.report.perDeliveredGrowFinisher' | translate
          }}</strong>
        </td>
        <td>
          <strong>{{
            'feed-profit.detail.extended-simulation.report.perKgGrowth' | translate
          }}</strong>
        </td>
      </tr>

      <tr>
        <td>
          {{
            'feed-profit.detail.extended-simulation.report.profit-per-delivered-grow-finisher'
              | translate
          }}
          ({{ currencySymbol }})
        </td>
        <td>
          {{ getSummaryValue(extendedSimulationData.comparison?.profitPerGrowFinisher) }}
        </td>
        <td>
          {{ getSummaryValue(extendedSimulationData.comparison?.profitGrowFinisherPerKg) }}
        </td>
        <td>
          {{ getSummaryValue(extendedSimulationData.extended?.profitPerGrowFinisher) }}
        </td>
        <td>
          {{ getSummaryValue(extendedSimulationData.extended?.profitGrowFinisherPerKg) }}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'feed-profit.settings.extended-baseline-settings.pigletPrice' | translate }} ({{
            currencySymbol
          }})
        </td>
        <td>{{ getSummaryValue(extendedSimulationData.comparison?.pigletPrice) }}</td>
        <td>
          {{ getSummaryValue(extendedSimulationData.comparison?.pigletPricePerKg) }}
        </td>
        <td>{{ getSummaryValue(extendedSimulationData.extended?.pigletPrice) }}</td>
        <td>{{ getSummaryValue(extendedSimulationData.extended?.pigletPricePerKg) }}</td>
      </tr>
      <tr>
        <td>
          {{ 'feed-profit.detail.extended-simulation.feeders.feed-costs' | translate }} ({{
            currencySymbol
          }})
        </td>
        <td>{{ getSummaryValue(extendedSimulationData.comparison?.feedCosts) }}</td>
        <td>
          {{ getSummaryValue(extendedSimulationData.comparison?.feedCostPerKgPerGrowth) }}
        </td>
        <td>{{ getSummaryValue(extendedSimulationData.extended?.feedCosts) }}</td>
        <td>
          {{ getSummaryValue(extendedSimulationData.extended?.feedCostPerKgPerGrowth) }}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'feed-profit.detail.extended-simulation.report.costDeathsAndSpoilage' | translate }}
          ({{ currencySymbol }})
        </td>
        <td>
          {{ getSummaryValue(extendedSimulationData.comparison?.costDeathsAndSpoilage) }}
        </td>
        <td>
          {{ getSummaryValue(extendedSimulationData.comparison?.costDeathsAndSpoilagePerKg) }}
        </td>
        <td>
          {{ getSummaryValue(extendedSimulationData.extended?.costDeathsAndSpoilage) }}
        </td>
        <td>
          {{ getSummaryValue(extendedSimulationData.extended?.costDeathsAndSpoilagePerKg) }}
        </td>
      </tr>
      <tr>
        <td>
          {{
            'feed-profit.detail.extended-simulation.report.feedprofit-per-average-present-grow-finisher'
              | translate
          }}
          ({{ currencySymbol }})
        </td>
        <td class="border-top">
          {{ getSummaryValue(extendedSimulationData.comparison?.feedProfitDelivered) }}
        </td>
        <td class="border-top">
          {{ getSummaryValue(extendedSimulationData.comparison?.feedProfitDeliveredPerKg) }}
        </td>
        <td class="border-top">
          {{ getSummaryValue(extendedSimulationData.extended?.feedProfitDelivered) }}
        </td>
        <td class="border-top">
          {{ getSummaryValue(extendedSimulationData.extended?.feedProfitDeliveredPerKg) }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div
  class="wrapper--spacing-horizontal"
  *ngIf="calculation && extendedSimulationData && extendedSimulationData.comparison"
>
  <table>
    <tbody>
      <tr>
        <!--header-->
        <td>
          <strong>{{
            'feed-profit.detail.extended-simulation.report.calculationFeedprofit' | translate
          }}</strong>
        </td>
        <td colspan="2">
          <strong>{{
            'feed-profit.detail.extended-simulation.report.avgAmountDeliveredGrowFinisherPerYear'
              | translate
          }}</strong>
        </td>
        <td colspan="2">
          <strong>{{
            'feed-profit.detail.extended-simulation.report.avgAmountDeliveredGrowFinisherPerYear'
              | translate
          }}</strong>
        </td>
      </tr>

      <tr>
        <td>
          <i>{{ 'feed-profit.detail.extended-simulation.report.costAndRevenue' | translate }}</i>
        </td>
        <td colspan="2">
          <i>{{ 'feed-profit.detail.extended-simulation.report.current' | translate }}</i>
        </td>
        <td colspan="2">
          <i>{{ 'feed-profit.detail.extended-simulation.report.alternative' | translate }}</i>
        </td>
      </tr>
      <tr>
        <td>
          {{ 'feed-profit.detail.extended-simulation.report.profit-grow-finisher' | translate }} ({{
            currencySymbol
          }})
        </td>
        <td colspan="2">
          {{
            getSummaryValue(extendedSimulationData.comparison?.feedProfitAverageGrowFinisherInYear)
          }}
        </td>
        <td colspan="2">
          {{
            getSummaryValue(extendedSimulationData.extended?.feedProfitAverageGrowFinisherInYear)
          }}
        </td>
      </tr>
      <tr>
        <td>
          {{
            'feed-profit.detail.extended-simulation.summary.table-headers.piglet-price' | translate
          }}
          ({{ currencySymbol }})
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.pigletPriceInYear) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.pigletPriceInYear) }}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'feed-profit.detail.extended-simulation.feeders.feed-costs' | translate }} ({{
            currencySymbol
          }})
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.feedCostsInYear) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.feedCostsInYear) }}
        </td>
      </tr>
      <tr>
        <td>
          {{ 'feed-profit.detail.extended-simulation.report.costDeathsAndSpoilage' | translate }}
          ({{ currencySymbol }})
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.costsDeathsAndSpoilageInYear) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.costsDeathsAndSpoilageInYear) }}
          ({{ currencySymbol }})
        </td>
      </tr>
      <tr>
        <td>
          {{
            'feed-profit.detail.extended-simulation.report.feedProfitPerDeliveredGrowFinisher'
              | translate
          }}
          ({{ currencySymbol }})
        </td>
        <td class="border-top">
          {{
            getSummaryValue(extendedSimulationData.comparison?.feedprofitAverageGrowFinisherYear)
          }}
        </td>
        <td>&nbsp;</td>
        <td class="border-top">
          {{ getSummaryValue(extendedSimulationData.extended?.feedprofitAverageGrowFinisherYear) }}
        </td>
        <td>&nbsp;</td>
      </tr>

      <tr>
        <td colspan="5">&nbsp;</td>
      </tr>
      <tr>
        <td>
          {{
            'feed-profit.detail.extended-simulation.summary.fertilizer.table-headers.feedprofit-per-meter-including-fertilizer'
              | translate
          }}
          ({{ currencySymbol }})
        </td>
        <td colspan="2">
          {{
            getSummaryValue(
              extendedSimulationData.comparison?.feedProfitPerSquareMeterInclFertilizer
            )
          }}
        </td>
        <td colspan="2">
          {{
            getSummaryValue(extendedSimulationData.extended?.feedProfitPerSquareMeterInclFertilizer)
          }}
        </td>
      </tr>

      <tr>
        <td colspan="5">&nbsp;</td>
      </tr>

      <tr>
        <td>
          {{ 'feed-profit.detail.extended-simulation.summary.fertilizer.title' | translate }}
        </td>
        <td colspan="4">&nbsp;</td>
      </tr>

      <tr>
        <td>
          {{
            'feed-profit.detail.extended-simulation.summary.fertilizer.table-headers.M3-fertilizer'
              | translate
          }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.comparison?.manureCubedProduction) }}
        </td>
        <td colspan="2">
          {{ getSummaryValue(extendedSimulationData.extended?.manureCubedProduction) }}
        </td>
      </tr>
      <tr>
        <td>
          {{
            'feed-profit.detail.extended-simulation.summary.fertilizer.table-headers.price'
              | translate
          }}
          ({{ currencySymbol }})
        </td>
        <td colspan="2">
          {{ getSummaryValue(calculation.extendedBaseLine?.fertilizerPricePerCubicMeter) }}
        </td>
        <td colspan="2">
          {{
            getSummaryValue(
              calculation.extendedSimulation?.extendedBaseLine?.fertilizerPricePerCubicMeter
            )
          }}
        </td>
      </tr>
      <tr>
        <td>
          {{
            'feed-profit.detail.extended-simulation.summary.fertilizer.table-headers.fertilizer-cost-per-present-grow-finisher'
              | translate
          }}
          ({{ currencySymbol }})
        </td>
        <td class="border-top">
          {{ getSummaryValue(extendedSimulationData.comparison?.fertilizerCostsPerGrowFinisher) }}
        </td>
        <td>&nbsp;</td>
        <td class="border-top">
          {{ getSummaryValue(extendedSimulationData.extended?.fertilizerCostsPerGrowFinisher) }}
        </td>
        <td>&nbsp;</td>
      </tr>
      <tr>
        <td colspan="5">&nbsp;</td>
      </tr>
      <tr>
        <td>
          {{
            'feed-profit.detail.extended-simulation.summary.fertilizer.table-headers.feedprofit-per-average-present-grow-finisher-including-fertilizer'
              | translate
          }}
          ({{ currencySymbol }})
        </td>
        <td colspan="2">
          {{
            getSummaryValue(
              extendedSimulationData.comparison?.feedProfitAverageGrowFinisherInclFertilizer
            )
          }}
        </td>
        <td colspan="2">
          {{
            getSummaryValue(
              extendedSimulationData.extended?.feedProfitAverageGrowFinisherInclFertilizer
            )
          }}
        </td>
      </tr>
      <tr>
        <td>
          {{
            'feed-profit.detail.extended-simulation.summary.fertilizer.table-headers.feedprofit-per-meter-including-fertilizer'
              | translate
          }}
          ({{ currencySymbol }})
        </td>
        <td colspan="2">
          <strong>
            {{
              getSummaryValue(
                extendedSimulationData.comparison?.feedProfitPerSquareMeterInclFertilizer
              )
            }}</strong
          >
        </td>
        <td colspan="2">
          <strong>
            {{
              getSummaryValue(
                extendedSimulationData.extended?.feedProfitPerSquareMeterInclFertilizer
              )
            }}</strong
          >
        </td>
      </tr>
    </tbody>
  </table>
</div>
